
export class RecuperarSenha {

  constructor(
    public dsTokenAcesso?: string,
    public dsEmail?: string,
    public nrFone?: number,
    public nrCpf?: string
  ) {
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/dominios/recuperar-senha.ts